import type { GuidedDockView, GuidedView } from "../routing/guided-views.js";
import { GUIDED_DOCK_LABELS } from "./guided-dock-labels.js";
import { EnreinBrandBlock } from "../../studio-shared/chrome/EnreinBrandBlock.js";

export function GuidedDock({
  activeView,
  onNavigate,
}: {
  readonly activeView: GuidedView;
  readonly onNavigate: (view: GuidedView) => void;
}) {
  const dockActive: GuidedDockView =
    activeView === "project" ||
    activeView === "new" ||
    activeView === "scan" ||
    activeView === "scan-opportunities"
      ? "home"
      : activeView === "more"
        ? "more"
        : activeView;

  return (
    <aside className="enrein-guided-dock" aria-label="Primary navigation">
      <EnreinBrandBlock />
      <nav className="enrein-guided-nav">
        {(["home", "projects", "more"] as const).map((view) => (
          <button
            key={view}
            type="button"
            className={dockActive === view ? "is-active" : ""}
            onClick={() => onNavigate(view === "home" ? "home" : view)}
          >
            {GUIDED_DOCK_LABELS[view]}
          </button>
        ))}
      </nav>
    </aside>
  );
}
